import React from "react";
import PropTypes from "prop-types";
import { BodyStrong, BodyFade } from "theme/components/atoms/Typography/Body";
import { FormattedMessage } from "react-intl";

/** @type {React.FunctionComponent<PropTypes.InferProps<typeof propTypes>>} */
const Switch = ({ title, description, checked, onChange }) => {
  const inputId = title.replace(/\W/g, "-").toLowerCase();

  return (
    <label className="switch">
      <div className="switch__main">
        <div className="switch__title">
          <BodyStrong>{title}</BodyStrong>
        </div>
        <div className="switch__interactive">
          <input
            type="checkbox"
            checked={checked}
            onChange={(event) => {
              onChange(event.target.checked);
            }}
            id={inputId}
          />
          <label htmlFor={inputId}>
            <FormattedMessage
              id="components.atoms.Switch.toggle"
              defaultMessage="Toggle"
            />
          </label>
        </div>
      </div>
      {Boolean(description) && (
        <div className="switch__description">
          <BodyFade>{description}</BodyFade>
        </div>
      )}
    </label>
  );
};

const propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};

Switch.propTypes = propTypes;

export default Switch;
